export default __webpack_public_path__ + "static/media/cart-button.b9d9946e.svg";